import React from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";
import { Helmet } from "react-helmet";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";



function Cex() {


  return (
    <div className="newpage header_section STO_txtcontent">
      <header className="newpage nft_new_page  ">
        {/* <Header /> */}
        <NewHead />
      </header>
      <div className="paddin_immner">
        <main className=" carer_page">
          <span>
            <Helmet>
              <title>
                STO Development Company | Security Token Offering Development
                Services | Beleaf Technology
              </title>
              <link
                rel="canonical"
                href="https://beleaftechnologies.com/sto-development-company"
              />
              <meta
                name="title"
                content="  STO Development Company | Security Token Offering Development
                Services | Beleaf Technology"
              />
              <meta
                name="description"
                content="Being a top STO development company, Beleaf technologies offers STO Services that aid you to launch own STO for your business and embellish your investments funds."
              />
              <meta
                name="keywords"
                content="Security Token Offering, Security Token Offering Services. STO Development, STO Development Company, STO Services, STO Development Services, sto development company, sto development services, sto token creation, security token development, security token development company, security token development services, create your own sto"
              />
            </Helmet>

            <section className="main_banner_swcrir">
              <div className="container banner_STO">
                <div className="row justify-content-center">
                  <div className="col-lg-8">
                    <div className="contcnt_headine">
                      <h1> STO Development Company</h1>
                      <p>
                        Unconditional support to raise funds for your venture
                        via high-quality STO development services with no risk!
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="m-auto d-block mt-4"
                      >
                        Get Free Consultation
                      </Button>
                    </div>
             
                  </div>
                </div>
              </div>
            </section>
            {/* <div className="ourserveic_banner ico-banner">
             
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="service_content">
                      <h1 className="text-center">
                        DRIVE ICO DEVELOPMENT TO RAISE FUNDS!!
                      </h1>
                      <p className="text-center mb-5">
                        Mission-driven ICO Development Services will accentuate
                        fundraising and energize your firm for long-term
                        success.
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="m-auto d-block mt-4"
                      >
                        Develop Your Own ICO Token
                      </Button>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <section className="section bg-light">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text-center text_center_new">
                        What exactly are Security Token Offerings?
                      </h2>
                      <p className="text-center">
                        Security tokens are blockchain-powered crypto tokens
                        that contain tangible and tradable assets such as
                        shares, dividends, land, gold, and so on in order to
                        generate funds from accredited investors worldwide.
                        These tokens provide the token holder with particular
                        rights such as dividends, profit sharing, voting rights,
                        buy-back rights, and much more, in order to gain the
                        trust of foreign investors to participate in your
                        company. Because security tokens are subject to the
                        federal rules and regulations of the relevant
                        government, it provides greater confidence and security
                        to both investors and token issuers.
                      </p>
                      <div className="button_CTA_block">
                        <Button
                          data-toggle="modal"
                          data-target="#myModal"
                        >
                          Catch Our Experts
                        </Button>
                        <a href="https://wa.me/7904323274" target="_blank">
                          Connect Us Via Whatsapp
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="first_section_crypto">
                      <h2 className="text-center">
                        Reputable Security Token (STO) Development Company
                      </h2>
                      <p className="">
                        Security Token Offerings assist entrepreneurs in
                        increasing the value of their investment money. STOs
                        guarantee investors' ownership of your company, bringing
                        massive capital to your business. Beleaf, a well-known
                        STO development firm, guarantees to provide you with
                        safe and dependable STO launch services at reasonable
                        pricing. Our developers have the most experience in the
                        field and go above and beyond to meet all of the
                        client's expectations in STO creation. The services we
                        provide under Security Token platform development
                        include consultancy, whitepaper drafting, website
                        design, smart contracts, and so on.
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                      >
                        Get Started Now
                      </Button>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="classs_banner_lanchpadu">
                      <img
                        src={require("../../image/cloudinary/iso2.webp")}
                        alt=" Reputable Security Token (STO) Development Company"
                        className="posyio-static"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light bg_line defi-staking-list height_SIO">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_center_new">
                        Various Kinds of Security Tokens
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="card_bg_whute card_heignt_section grid_ful_height_tab">
                  <div className="row justify-content-center">
                    <div className="col-lg-6">
                      <div className="card_">
                        <h3>Equity Token</h3>
                        <p>
                          The equity token denotes ownership of a company's
                          stock. It works similarly to traditional stock
                          exchanges, except that the databases are stored on an
                          unchangeable blockchain.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="card_">
                        <h3>Utility Tokens</h3>
                        <p>
                          Utility tokens can be issued in order to raise funding
                          for the development of a business enterprise. This
                          token grants clients later access to certain
                          products/services.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="card_">
                        <h3>Reserve Assets Token</h3>
                        <p>
                          Reserve assets tokens represent tangible assets such
                          as gold, land, and buildings. Companies that trade
                          these types of assets can utilise STOs to provide
                          their investors particular rights over the actual
                          assets.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="card_">
                        <h3>Debt Tokens</h3>
                        <p>
                          When a company does not have any stocks or assets to
                          tokenize, debt tokens are distributed. These tokens
                          ensure the repayment of profits or assets in the
                          future.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <div className="col-lg-6">
                      <div className="footer_cerd">
                        <div className="row">
                          <div className="col-lg-12">
                            <h2>Are you looking to develop a STO token</h2>
                            <Button
                              data-toggle="modal"
                              data-target="#myModal"
                            >
                              Contact Us
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto ">
                      <h2 className="text-center text_center_new">
                        What kind of assets are tokenizable?
                      </h2>
                    </div>
                    <ul className="row list_item_d justify-content-center">
                      <li className="col-lg-6">
                        <div className="dtatas fetures_cardwe">
                          <div className="first_section_crypto">
                            <img
                              src={require("../../image/new/P2P/thinking.webp")}
                              alt="Feb-Business_9-ai"
                              className="whta_imgss"
                            />
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <ul className="how_tradee pt-5">
                              <li>
                                <span>
                                  {" "}
                                  <i className="bi bi-patch-check-fill"></i>
                                </span>{" "}
                                Real Estate
                              </li>
                              <li>
                                <span>
                                  {" "}
                                  <i className="bi bi-patch-check-fill"></i>
                                </span>
                                Arts
                              </li>
                              <li>
                                <span>
                                  {" "}
                                  <i className="bi bi-patch-check-fill"></i>
                                </span>{" "}
                                Venture Capital
                              </li>
                              <li>
                                <span>
                                  {" "}
                                  <i className="bi bi-patch-check-fill"></i>
                                </span>{" "}
                                Rare Collectibles
                              </li>
                              <li>
                                <span>
                                  {" "}
                                  <i className="bi bi-patch-check-fill"></i>
                                </span>{" "}
                                Liquid Assets
                              </li>
                              <li>
                                <span>
                                  {" "}
                                  <i className="bi bi-patch-check-fill"></i>
                                </span>
                                Precious metal
                              </li>
                              <li>
                                <span>
                                  {" "}
                                  <i className="bi bi-patch-check-fill"></i>
                                </span>
                                Sports Teams and Celebrities
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light">
              <div className="container pt-5">
                <div className="card_CTA_neww_ww">
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="first_section_crypto ">
                        <h2 className="text-center ">
                          Do You Wanna Increase Project Funding Through Security
                          Token Offerings? Hire Our Professionals for the Best
                          STO Development Services.
                        </h2>
                      </div>
                    </div>
                    <div className="col-lg-4 col_CTA_btn">
                      <div className="img_clas_butn">
                        <Button
                          data-toggle="modal"
                          data-target="#myModal"
                        >
                          Call Us Now
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto ">
                      <h2 className="text-center text_center_new">
                        End-To-End Process in Developing Security Token Offering
                        Services
                      </h2>
                      <p className="text-center">
                        We offer a complete turnkey solution for the STO
                        project, including the following outstanding service
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="timeline">
                      <div className="outer">
                        <div className="cardnew">
                          <div className="info">
                            <h3 className="title">
                              {" "}
                              Legal & Landing page services
                            </h3>
                            <p>
                              Learn more about the securities that can be
                              tokenized in order to raise funds from our team.
                              We will create security tokens based on your
                              specifications, and we also have a legal partner
                              who will assist you in launching security tokens
                              in accordance with government norms and
                              regulations.
                            </p>
                          </div>
                        </div>
                        <div className="cardnew">
                          <div className="info">
                            <h3 className="title">
                              {" "}
                              Equity Token Offering (ETO) services
                            </h3>
                            <p className="text-right">
                              By issuing equity tokens as a security, legally
                              established corporations can tokenize their assets
                              and raise cash. We specialise in creating bespoke
                              equity tokens that provide investors with
                              specified rights such as voting rights, profit
                              share, dividends, and so on.
                            </p>
                          </div>
                        </div>
                        <div className="cardnew">
                          <div className="info">
                            <h3 className="title">Security Token Development</h3>
                            <p>
                              Possess a security token in order to attract
                              overseas investors for your company fund. Our
                              staff will provide you with comprehensive advice
                              throughout the token generation process, including
                              KYC identity, token creation, pre-sale, smart
                              contracts for token minting, and smart contracts
                              for crowd sale.
                            </p>
                          </div>
                        </div>
                        <div className="cardnew">
                          <div className="info">
                            <h3 className="title">STO Marketing Activities</h3>
                            <p className="text-right">
                              Marketing is a way for investors to learn about
                              your security tokens and decide whether or not to
                              invest. We provide end-to-end marketing support to
                              help you effectively launch your STO by adhering
                              to security token criteria.
                            </p>
                          </div>
                        </div>
                        <div className="cardnew">
                          <div className="info">
                            <h3 className="title">STO Exchange Platform</h3>
                            <p>
                              The STO exchange platform allows users to exchange
                              tokens in a safe environment. We provide bespoke
                              trading platforms for Security token exchange
                              platforms and assist you in effortlessly
                              exchanging your tokens at a lesser price.
                            </p>
                          </div>
                        </div>
                        <div className="cardnew">
                          <div className="info">
                            <h3 className="title">
                              Tokenized Offering Assets(TAO) Developmen
                            </h3>
                            <p className="text-right">
                              Tokenized Asset Offerings (TAO) are lawful
                              tokenizations of assets that adhere to the federal
                              requirements of the respective government. We help
                              you turn your real estate and illiquid assets into
                              enticing tokens in order to attract accredited
                              investors.
                            </p>
                          </div>
                        </div>
                        <div className="cardnew">
                          <div className="info">
                            <h3 className="title text-center">
                              Start a successful STO Token Development!
                            </h3>
                            <Button
                              data-toggle="modal"
                              data-target="#myModal"
                            >
                              Request For Proposal
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto ">
                      <h2 className="text-center text_center_new">
                        Customized Strategy for Developing a Stable STO
                      </h2>
                      <p className="text-center">
                        Simple Steps to Launching Your Own STO
                      </p>
                    </div>
                    <ul className="row list_item_d justify-content-center">
                      <li className="col-lg-6">
                        <div className="advantage_section_setting">
                          <div className="icon_advantage">
                            <img
                              src={require("../../image/new/construction.webp")}
                              alt="Feb-Business_9-ai"
                              className=""
                            />
                          </div>
                          <div className="conatee_et">
                            <h3>The Groundwork</h3>
                            <p>
                              The launch of a STO begins with the groundwork
                              phase, which includes legal consultation,
                              regulation clarification, use case identification,
                              and website development.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="advantage_section_setting">
                          <div className="icon_advantage">
                            <img
                              src={require("../../image/new/preparation.webp")}
                              alt="Feb-Business_9-ai"
                              className=""
                            />
                          </div>
                          <div className="conatee_et">
                            <h3>Pre-STO Preparation</h3>
                            <p>
                              The second stage of STO launch is Pre STO
                              preparation, which includes website publishing,
                              whitepaper drafting, token and smart contract
                              creation, and POC release.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="advantage_section_setting">
                          <div className="icon_advantage">
                            <img
                              src={require("../../image/new/investor.webp")}
                              alt="Feb-Business_9-ai"
                              className=""
                            />
                          </div>
                          <div className="conatee_et">
                            <h3>Accredited Investor Approaching</h3>
                            <p>
                              This phase is responsible for custodian
                              integration, the construction of smart contracts
                              for holding and regulations, and the publication
                              of the alpha version.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="advantage_section_setting ">
                          <div className="icon_advantage">
                            <img
                              src={require("../../image/new/poster.webp")}
                              alt="Feb-Business_9-ai"
                              className=""
                            />
                          </div>
                          <div className="conatee_et">
                            <h3>Post-STO Activities</h3>
                            <p>
                              The post-STO operations include the progression of
                              specific tasks like as support, marketing, and
                              maintenance.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div className="col-lg-12 first_section_crypto">
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="m-auto mt-4 margin_top_p"
                      >
                        Create your own STO
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="dex_third_conetnt">
                      <h2 className="mb-3">Benefits of Our STO services</h2>
                      <p className="text-center mb-5">
                        Tokenizing assets benefits both the issuer and the
                        investors. Tokenization provides the following
                        advantages
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="futerr_conete card_P2P_new">
                      <div className="row justify-content-center">
                        <div className="col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section estae_class">
                              <img
                                src={require("../../image/new/house.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Commercial Real Estate</h4>
                            <p>
                              Having STO for commercial real estate can make
                              your real-world investments more reliable and
                              accessible digitally and worldwide.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section estae_class">
                              <img
                                src={require("../../image/new/stable.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Stable Coins</h4>
                            <p>
                              Optimize price volatility by tokenizing assets
                              such as gold, land, and so on with stablecoin in
                              order to raise funds more effectively.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section estae_class">
                              <img
                                src={require("../../image/new/capital.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Equity Capital Markets</h4>
                            <p>
                              The equity capital market serves both the issuer
                              and the investors by providing funds for business
                              and certainty to investors.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section estae_class">
                              <img
                                src={require("../../image/new/venture.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Venture Capital</h4>
                            <p>
                              Tokenization allows investors to gain access to
                              their investment funds without the requirement for
                              an intermediary.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section estae_class">
                              <img
                                src={require("../../image/new/loan.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Debt Capital Markets (DCM)</h4>
                            <p>
                              Custom advice from professionals on obtaining debt
                              for acquisitions, refinancing, or restructuring
                              existing debt can benefit the issuer.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section estae_class">
                              <img
                                src={require("../../image/new/intangible-asset.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Intangible Asset</h4>
                            <p>
                              Some assets are not easily convertible into cash.
                              Tokenization can benefit the issuer and enhance
                              trade volume without causing any loss in asset
                              value.
                            </p>
                          </div>
                        </div>

                        <div className="col-lg-12 first_section_crypto">
                          <Button
                            data-toggle="modal"
                            data-target="#myModal"
                            className="m-auto mt-4 margin_top_p"
                          >
                            Get A Quote
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white ">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_ceeenter">
                        Tech Stack for STO development
                      </h2>
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="smart_content">
                      <h3>Framework</h3>
                      <ul>
                        <li>
                          <img
                            src={require("../../image/ai/rust_img.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Rust</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/DEFI/solana-sol-logo.webp")}
                            alt="blockchian"
                          />
                          <p>Solana Tool Suite</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/frame-node.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Node JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/frame-etherjs.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Ether.JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/frame-web3js.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>web3.JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/Frame-react.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>React.JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/Frame-anguler.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Angular JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/frame-next-js.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Next.JS</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="section bg-light turstss_blss">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="first_section_crypto white_security white_benifit">
                          <h2 className="">
                            Why Choose Beleaf For Your STO Development?
                          </h2>
                          <p className="">
                            Our entire STO development team works with an
                            extensive knowledge base and best practises to
                            ensure the success and profitability of your
                            venture. With our Security Offering services,
                            attracting investors, and creating long-term brand
                            value are no longer arduous tasks with our Security
                            Token. We ensure our effectiveness as a STO
                            developer, which has led to our position as a
                            leading security token offering development firm.
                          </p>
                          <ul>
                            <li>
                              <span>
                                <i className="bi bi-check2-all"></i>
                              </span>
                              Increased business market efficiency
                            </li>
                            <li>
                              <span>
                                <i className="bi bi-check2-all"></i>
                              </span>
                              Fractionalization
                            </li>
                            <li>
                              <span>
                                <i className="bi bi-check2-all"></i>
                              </span>
                              Client support has been improved.
                            </li>

                            <li>
                              <span>
                                <i className="bi bi-check2-all"></i>
                              </span>
                              Massive investment funds
                            </li>
                            <li>
                              <span>
                                <i className="bi bi-check2-all"></i>
                              </span>
                              Expert staff On-time delivery Reasonable price
                            </li>
                            <li>
                              <span>
                                <i className="bi bi-check2-all"></i>
                              </span>
                              Global business relations
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <img
                          src={require("../../image/cloudinary/iso20055-ai_vrbwu9.webp")}
                          alt=" Why Choose Beleaf For Your STO Development ?"
                          className=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light">
              <div className="container">
                <div className="contanineee_circle">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="first_section_crypto colo_white card_CTAA">
                        <h2 className="">
                          We assist businesses in launching legally compliant
                          security tokens! Consult Our STO Experts
                        </h2>
                        <a
                         data-toggle="modal"
                  data-target="#myModal"
                          className="grabcall"
                        >
                          Book A Demo Now{" "}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section id="about why new_faq bg_white CEX_faq">
              <section className="section bg_white CEX_faq" id="">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 d-flex align-items-center">
                      <div className="whybelaf faq">
                        <h2 className="">
                          Frequently asked <br />
                          Question
                        </h2>
                        <p></p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="comtent">
                        <div id="main">
                          <div className="container">
                            <div className="accordion" id="faq">
                              <div className="card">
                                <div className="card-header" id="faqhead1">
                                  <a
                                    href="#"
                                    className="btn btn-header-link"
                                    data-toggle="collapse"
                                    data-target="#faq1"
                                    aria-expanded="true"
                                    aria-controls="faq1"
                                  >
                                    What exactly is a Security Token Offer?
                                  </a>
                                </div>

                                <div
                                  id="faq1"
                                  className="collapse show"
                                  aria-labelledby="faqhead1"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    STO stands for the company's stock. To raise
                                    revenue for the business initiative, they
                                    are tokenized and sold on global markets.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead2">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq2"
                                    aria-expanded="true"
                                    aria-controls="faq2"
                                  >
                                    How can I pick the best STO development
                                    firm?
                                  </a>
                                </div>

                                <div
                                  id="faq2"
                                  className="collapse"
                                  aria-labelledby="faqhead2"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    You can search Google for STO development
                                    companies and get a big list of results. You
                                    can then filter the best one by looking at
                                    their websites for client testimonials, the
                                    number of successfully completed projects,
                                    the skill of their developers, and so on.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead3">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq3"
                                    aria-expanded="true"
                                    aria-controls="faq3"
                                  >
                                    How do you ensure that my business concept
                                    is safe with you?
                                  </a>
                                </div>

                                <div
                                  id="faq3"
                                  className="collapse"
                                  aria-labelledby="faqhead3"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    We sign a non-disclosure agreement at the
                                    start of the project to ensure that your
                                    details are kept private. You can be certain
                                    of it.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead4">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq4"
                                    aria-expanded="true"
                                    aria-controls="faq4"
                                  >
                                    I may need multiple modifications. Will you
                                    be able to assist me?
                                  </a>
                                </div>

                                <div
                                  id="faq4"
                                  className="collapse"
                                  aria-labelledby="faqhead4"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Absolutely. Our custom-made solutions are
                                    adaptable enough to meet specific corporate
                                    requirements. Whatever your needs are, tell
                                    us about them and we'll make them a reality.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead5">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq5"
                                    aria-expanded="true"
                                    aria-controls="faq5"
                                  >
                                    I'll need help after the app is released.
                                    Will you back me up?
                                  </a>
                                </div>

                                <div
                                  id="faq5"
                                  className="collapse"
                                  aria-labelledby="faqhead5"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Yes, absolutely! We offer technical help
                                    even after the launch, subject to the terms
                                    and circumstances agreed upon when the
                                    contract was signed.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </section>
          </span>
          {/* <Commonpage /> */}
        </main>
      </div>

      {/* <Footer /> */}
      <ServiceFooter />
    </div>
  );
}

export default Cex;
